import { toReal, toRad, toDegree } from './threejsUtils'
const THREE = window.THREE;

// To find orientation of ordered triplet (p, q, r).
// The function returns following values
// 0 --> p, q and r are collinear
// 1 --> Clockwise
// 2 --> Counterclockwise
export function orientation1(p, q, r) {
	let val = (q.y - p.y) * (r.x - q.x) -
		(q.x - p.x) * (r.y - q.y);

	if (val == 0) return 0;  // collinear
	return (val > 0) ? 1 : 2; // clock or counterclock wise
}

// Prints convex hull of a set of n points.
export function convexHull(points) {
	let n = points.length;
	// There must be at least 3 points
	if (n < 3) return;

	// Initialize Result
	let hull = [];

	// Find the leftmost point
	let l = 0;
	for (let i = 1; i < n; i++)
		if (points[i].x < points[l].x)
			l = i;

	// Start from leftmost point, keep moving
	// counterclockwise until reach the start point
	// again. This loop runs O(h) times where h is
	// number of points in result or output.
	let p = l, q;
	do {

		// Add current point to result
		hull.push(points[p]);

		// Search for a point 'q' such that
		// orientation(p, q, x) is counterclockwise
		// for all points 'x'. The idea is to keep
		// track of last visited most counterclock-
		// wise point in q. If any point 'i' is more
		// counterclock-wise than q, then update q.
		q = (p + 1) % n;

		for (let i = 0; i < n; i++) {
			// If i is more counterclockwise than
			// current q, then update q
			if (orientation1(points[p], points[i], points[q])
				== 2)
				q = i;
		}

		// Now q is the most counterclockwise with
		// respect to p. Set p as q for next iteration,
		// so that q is added to result 'hull'
		p = q;

	} while (p != l);  // While we don't come to first
	// point
	hull.push(hull[0]);
	return hull;
}

//https://stackoverflow.com/questions/22521982/check-if-point-is-inside-a-polygon
export function isInsidePoly(point, vs) {
    // ray-casting algorithm based on
    // https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html/pnpoly.html
    
    var x = point.x, y = point.y;
    
    var inside = false;
    for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
        var xi = vs[i].x, yi = vs[i].y;
        var xj = vs[j].x, yj = vs[j].y;
        
        var intersect = ((yi > y) != (yj > y))
            && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
        if (intersect) inside = !inside;
    }
    
    return inside;
}


//got the code from this page
//https://www.andre-gaschler.com/rotationconverter/
export function axisAngleToEuler(x, y, z, angle) {
    var q = new THREE.Quaternion();
    let axis = new THREE.Vector3(x,y,z);
    axis.normalize();
    q.setFromAxisAngle(axis, toRad(angle));
    q.normalize();

    var m = new THREE.Matrix4();
    m.makeRotationFromQuaternion(q);
    axis = [0, 0, 0];
    angle = 2 * Math.acos(q.w);
    if (1 - (q.w * q.w) < 0.000001)
    {
        axis[0] = q.x;
        axis[1] = q.y;
        axis[2] = q.z;
    }
    else
    {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/
        var s = Math.sqrt(1 - (q.w * q.w));
        axis[0] = q.x / s;
        axis[1] = q.y / s;
        axis[2] = q.z / s;
    }
    var eu = new THREE.Euler();
    eu.setFromRotationMatrix(m, 'ZYX');
    let rotationX = toReal(toDegree(eu.toArray()[0]));
    let rotationY = toReal(toDegree(eu.toArray()[1]));
    let rotationZ = toReal(toDegree(eu.toArray()[2]));

    return {x: rotationX, y:rotationY, z:rotationZ};
}
